export const blockIconsSocialPublicNew = (
	<span className='material-symbols-outlined'>public</span>
);
